{
    "pre_referral_step1": {
        "sectionId": "pre_referral_step1",
        "header_1": "Provider Interest",
        "text_1": "Please start by telling us some details",
        "available_actions": [
            {
                "button_name": "begin_referall_id",
                "isAvailable": "Y"
            }
        ],
        "attributes": [
            {
                "attribute_ID": "state",
                "fieldName": "state",
                "label": "What is your state of residence?",
                "type": "dropdown",
                "mandatory": "Y",
                "validator": null,
                "tooltip": "Please specify your state of residence",
                "isAvailable": "Y",
                "placeholder": "Select State"
            },
            {
                "attribute_ID": "providerType",
                "fieldName": "providerType",
                "label": "Provider Type",
                "type": "dropdown",
                "mandatory": "Y",
                "validator": null,
                "tooltip": "Please specify Provider Type",
                "isAvailable": "Y",
                "placeholder": "Select Provider Type"
            }
        ],
        "validations": [
            {
                "whatToCheck": "atLeastXEntered",
                "clientOrServer": "C",
                "attributes": [
                    {
                        "validatorid": 1,
                        "attribute_ID": [
                            "state"
                        ],
                        "functionParams": {
                            "ErrMsg": "Please select your State of Residence"
                        }
                    },
                    {
                        "validatorid": 2,
                        "attribute_ID": [
                            "providerType"
                        ],
                        "functionParams": {
                            "ErrMsg": "Please select the Provider Type"
                        }
                    }
                ]
            }
        ],
        "actions": [
            {
                "Name": "Next",
                "Validate": [
                    {
                        "checkType": "atLeastXEntered",
                        "validatorid": [
                            1
                        ]
                    }
                ]
            }
        ]
    }
}